import React from 'react';
import {
    formatVisibleNumber,
    getSelfcare360IprTier,
} from './selfcare360Scales';
import './resumeSelfcare360.css';

const IpraCard = ({ value, marginOfError }) => {
    const safeValue = typeof value === 'number' ? value : Number(value);
    const ipra = Number.isFinite(safeValue) ? safeValue : 0;
    const tier = getSelfcare360IprTier(ipra);

    return (
        <div className="selfcare360-ipra-card" style={{ backgroundColor: tier.color, color: tier.textColor }}>
            <div className="selfcare360-ipra-title">IPRA</div>
            <div className="selfcare360-ipra-value" style={{ display: 'flex', alignItems: 'baseline' }}>
                {formatVisibleNumber(ipra)}
                {marginOfError !== undefined && marginOfError > 0 && (
                    <span style={{ fontSize: '0.34em', marginLeft: '4px', opacity: 0.9 }}>
                        ±{formatVisibleNumber(marginOfError)}
                    </span>
                )}
            </div>
            <div className="selfcare360-ipra-label">{tier.label}</div>
        </div>
    );
};

export default IpraCard;
